var exports = {
  "n": "xe533113f--e893fd--circle",
};

module.exports = exports;
